import { render, staticRenderFns } from "./ChannelsListItem.vue?vue&type=template&id=790c288a&"
import script from "./ChannelsListItem.vue?vue&type=script&lang=js&"
export * from "./ChannelsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports